module.exports = __webpack_public_path__ + "static/tracer-tile-sq-isometric-dl-410cecb1ac7ad2a9a7a7f5e6c4a074af.png";